// "My lessons" filter. Holders of lessons.viewAll always see every lesson, and
// read-only sport lessons are always listed. This only narrows what the page
// shows, the server decides what is allowed.
export const isLessonVisible = (lesson, { showMyLessons, canViewAll, uid }) => {
  if (!showMyLessons || canViewAll || lesson?.readOnly) return true;
  return (
    String(lesson?.teacher) === String(uid) ||
    (lesson?.list_students || []).map(String).includes(String(uid))
  );
};
